import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsParametersComponent } from './reports-parameters/reports-parameters.component';
import { AngularMaterialModule } from '../angular-material.module';
import { FormsModule } from '@angular/forms';
import { SharedControlsModule } from '../shared-controls/shared-controls.module';
import { HttpClientModule } from '@angular/common/http';
import { AclDataModule } from '../acl-data/acl-data.module';

@NgModule({
    declarations: [ReportsParametersComponent],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormsModule,
        SharedControlsModule,
        HttpClientModule,
        AclDataModule,
    ],
})
export class ReportsModule {}
